export default "<p>forbidden works!</p>\r\n"